import React, { useEffect } from 'react'
import useCompanies from '../../hooks/useCompanies';
import Loader from '../../components/Loader';
import Table from './Table';
import FormModal from './FormModal';
import { useNavigate } from 'react-router-dom';
import { getTabPaneClassName } from './tabUtils';
import resolveCompanyId from '../../utils/resolveCompanyId';

const Team = ({ company, tab, isManager, branchID }) => {
    const labels = ['#', 'Name', 'Position', 'Site Name', 'Actions'];
    const {
        managers,
        branches,
        loading,
        deleteLoading,
        addLoading,
        data,
        setData,
        fetchEmployees,
        fetchBranches,
        removeEmployee,
        addEmployee,
        changeEmployee,
    } = useCompanies();
    const navigator = useNavigate()
    const companyId = resolveCompanyId(company);

    const onView = (data)=>{
        navigator(`/user-profile?id=${data._id}`,{state:data})
    }
    useEffect(() => {
        if (companyId && tab?.includes('team')) {
            fetchEmployees(companyId, {
                position: isManager ? 'Supervisor' : '',
                branchID
            });
            fetchBranches(companyId, branchID);
        }
    }, [companyId, tab, isManager, branchID])

    const isUpdate = !!data?._id;
    const existingManager = managers.find(item => item.position == 'Manager');

    const fields = [
        {
            placeholder: 'Member Name',
            value: data?.name,
            setValue: (value) => setData({ ...data, name: value }),
            className: 'col-md-6'
        },
        {
            placeholder: 'Member Email',
            value: data?.email,
            setValue: (value) => setData({ ...data, email: value }),
            className: 'col-md-6'
        },
        isManager ? null : {
            placeholder: 'Select Site...',
            value: data?.branchID,
            setValue: (value) => setData({ ...data, branchID: value }),
            className: 'col-md-6',
            type: 'dropdown',
            options: branches
        },
        {
            placeholder: 'Select Role...',
            value: data?.position,
            setValue: (value) => setData({ ...data, position: value }),
            className: isManager ? 'col-md-12' : 'col-md-6',
            type: 'dropdown',
            options: [
                { _id: 'Supervisor', name: 'Supervisor' },
                { _id: 'Guest', name: 'Guest' },
                { _id: 'HR', name: 'HR Manager' },
                { _id: 'Employee', name: 'Employee' },
                isManager ? null : { _id: 'Manager', name: 'Manager' }
            ].filter(item => item)
        },
    ].filter(item => item)

    return (
        <div className={getTabPaneClassName(tab, "#profile-manage-team")} id="profile-manage-team">
            <div className="table-container">
                <Loader loading={loading} center>
                    <Table
                        labels={labels}
                        data={managers?.map(item => ({
                            cells: [item?.name, item?.position, branches?.find(b => b._id == item.branchID)?.name],
                            data: item
                        }))}
                        onDelete={removeEmployee}
                        onView={onView}
                        onEdit={(item) => setData({ ...item, show: true })}
                        onAdd={() => setData({ show: true })}
                        deleteLoading={deleteLoading}
                    />
                </Loader>
            </div>
            <FormModal
                show={data.show == true}
                title={isUpdate ? 'Update Member' : 'New Member'}
                onSubmit={isUpdate ? () => changeEmployee(companyId) : () => addEmployee(companyId)}
                fields={fields}
                onClose={() => setData({ ...data, show: false })}
                loading={addLoading}
            />
        </div>
    )
}

export default Team